import { LitElement, css, html } from 'lit'
//import { useEffect } from 'haunted'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js';

@customElement('ep-code')
export class EPCode extends LitElement {

  @property({ type: Boolean, reflect: true })
  accent = false

  render() {
    return html`
      <code class=${classMap({ code: true, accent: this.accent })}><slot></slot></code>
    `
  }

  static styles = css`
    :host {
      --font-monospace: ui-monospace, SFMono-Regular, SF Mono, Menlo, "Cascadia Mono", Consolas, Liberation Mono, monospace;
      display: contents;
    }

    .code {
      background: #F6F8FA;
      border: 1px solid #E5E7EB;
      border-radius: 4px;
      padding: 3px 6px;
      font-size: 0.9em;
    }
    .code.accent {
      color: #d63384;
    }

    * {
      box-sizing: border-box;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-code': EPCode
  }
}
